import { formatTimestamp } from "../../../utils/helper";

export const PartPaymentPill = (props: { value: any, className?: string }) => {
    const { value, className = "" } = props
    const isActive = value === true || value === "true"
    return (
        <span className={`inline-block whitespace-nowrap px-1.5 py-0.5 rounded text-[11px] font-medium border ${isActive ? "bg-green-100 text-green-800 border-green-200" : "bg-red-100 text-red-800 border-red-200"} ${className}`}>
            {isActive ? "Enabled" : "Disabled"}
        </span>
    )
}

const PartPaymentListItem = (props: any) => {
    const { data } = props

    if (!data.length) {
        return (
            <tr>
                <td colSpan={5} className="px-4 py-12 text-center text-xs text-gray-500">No products found.</td>
            </tr>
        )
    }

    return (
        <>
            {data.map((item: any) => (
                <tr key={item.id} className='[&:nth-child(odd)]:bg-[#f7f7f7]'>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[25%]">{item.productId}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[15%]">
                        <PartPaymentPill value={item.active} />
                    </td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[20%]">{item.createdOn ? formatTimestamp(item.createdOn) : "—"}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[20%]">{item.updatedOn ? formatTimestamp(item.updatedOn) : "—"}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[20%]">{item.updatedBy || "—"}</td>
                </tr>
            ))}
        </>
    )
}

export default PartPaymentListItem;
